export default __webpack_public_path__ + "static/media/mediterranean.40349bf3.jpg";